import axios from "axios";
import { z } from "zod";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
import { TaxBudgetId, } from "../../Types";
import { stringifyQueryParams } from "../../utils/stringifyQueryParams";
import ValidationError from "../../ZodError";
export const GetConsumedBudgetResponse = z.object({
    budgetId: z.nullable(TaxBudgetId),
    capitalConsequences: z.object({
        shortTermNetGainsLossesDollars: z.number(),
        longTermNetGainsLossesDollars: z.number(),
        estimatedShortTermTaxesDollars: z.number(),
        estimatedLongTermTaxesDollars: z.number(),
    }),
});
export const url = (clientId) => environment() === "PROD"
    ? `https://middleware.prod.farther.com/clientops/v1/clients/${clientId}/tax-consumption`
    : `https://middleware.uat.farther.com/clientops/v1/clients/${clientId}/tax-consumption`;
export default async function getConsumedBudget(params, config) {
    const { clientId, ...queryParams } = params;
    const { data } = await axios.get(url(clientId), {
        headers: {
            Authorization: `Bearer ${config.jwt}`,
            ...("advisorId" in config && { Advisor: config.advisorId }),
            ...("clientId" in config && { Client: config.clientId }),
        },
        params: queryParams,
        paramsSerializer: {
            serialize: (params) => stringifyQueryParams(params),
        },
    });
    const decoded = GetConsumedBudgetResponse.safeParse(data);
    if (decoded.success) {
        return decoded.data;
    }
    else {
        const errorMessage = "[getConsumedBudget] returned unexpected data.";
        errorLog(getConsumedBudget.name, JSON.stringify(decoded.error.issues));
        throw new ValidationError(errorMessage, decoded.error.issues);
    }
}
//# sourceMappingURL=getConsumedBudget.js.map